import type { ComponentChildren } from 'preact';
import { useMemo } from 'preact/hooks';
import { Link as WouterLink } from 'wouter-preact';

import { classes } from '../utils/classes.ts';
import css from './Link.module.css';

interface Props {
  readonly class?: string;
  readonly variant?: 'plain' | 'underline' | 'nav';
  readonly href: string;
  readonly target?: string;
  readonly children?: ComponentChildren;
}

export const Link = ({ class: outerClass, variant = 'underline', href, target, children }: Props) => {
  const className = classes(
    css.link,
    variant === 'underline' && css.linkUnderline,
    variant === 'nav' && css.linkNav,
    outerClass,
  );

  const type = useMemo(() => {
    if (href.startsWith('#')) return 'hash';
    if (target) return 'external';
    if (new URL(href, window.location.href).origin !== window.location.origin) return 'external';
    return 'internal';
  }, [href, target]);

  if (type !== 'internal') {
    return (
      <a class={className} href={href} target={target || (type === 'hash' ? '_self' : '_blank')} rel="noreferrer">
        {children}
      </a>
    );
  }

  return (
    <WouterLink
      class={className}
      href={href}
      onClick={(ev) => {
        if (new URL(href, window.location.href).href === window.location.href) {
          ev.preventDefault();
        }
      }}
    >
      {children}
    </WouterLink>
  );
};
